import { getIANATimezoneStringForAbbreviation } from 'helpers/sf_utils';
import React, { useMemo } from 'react';
import DateRangePicker, { DATE_RANGE_OPTIONS, SINGLE_DATE_OPTIONS, createOption } from 'components/Common/DateRangePicker';

/**
 * DOBInputWithLabel Component
 * @param {string} propertyLabel - The label text for the input field (e.g., 'Date of Birth')
 * @param {string} propertyName - The name attribute for the input field (e.g., 'dob')
 * @param {any} propertyValue - The value of the input field (depends on the input type, e.g., date value)
 * @param {Function} handlePropertyChange - The function triggered on input change (e.g., onChange handler)
 * @param {any} propertyResourceValue - The value of the resource property (related to the input, if any)
 * @param {Function} handlePropertyResourceChange - The function to handle changes in the resource property
 * @param {string} currentAccountTimeZone - The timezone associated with the current account (e.g., 'UTC')
 * @returns {JSX.Element} - Returns a JSX element representing the component
 */
const DOBInputWithLabel = ({
    index,
    filter,
    handle_filter_values,
    timezone
}) => {
    const allowSingleDateSelection = useMemo(() => {
        return filter?.single_date_selection || false;
    }, [filter])
    
    const dateRangeOptions = Object.keys(allowSingleDateSelection ? SINGLE_DATE_OPTIONS : DATE_RANGE_OPTIONS).map((opt) =>
        createOption(
            DATE_RANGE_OPTIONS[opt],
            new Date(),
            getIANATimezoneStringForAbbreviation(timezone)
        )
    ) || [];

    return (
        <DateRangePicker
            ianaTz={getIANATimezoneStringForAbbreviation(timezone)}
            value={filter?.value}
            options={dateRangeOptions}
            onChange={(value) => handle_filter_values(index, value)}
            allowSingleDateSelection={allowSingleDateSelection}
            maxDate={new Date()}
        />
    );
};

export default DOBInputWithLabel;
